import React, { useContext, useRef } from 'react'
import { genderIcons } from 'app/constants'
import { useIntl, useToggle, useOnClickOutside } from 'hooks'
import { useGetTagsQuery } from 'services'
import { generateAllForQuery } from 'utils/helpers'
import { getAgeFromDob, format } from 'utils/datetime'
import { PatientContext } from 'features/surgical-cloud/PatientsCollections'
import ContextMenu from 'components/ContextMenu'
import TagPills from 'components/TagPills'
import './index.css'

const PatientDetailsHeader = ({ onDelete, onShare, onAddTag, onDownload, onAddToCollection }) => {
    const { t } = useIntl()
    const { isOpen, onClose, onToggle } = useToggle(false)
    const { patient } = useContext(PatientContext)
    const myRef = useRef(null)

    const { data } = useGetTagsQuery(
        {
            query: generateAllForQuery({ type: 'patient', id: patient.id }),
            extraArgs: { id: `p:${patient.id}` },
        },
        {
            skip: !patient.id,
        }
    )

    useOnClickOutside(myRef, onClose, patient.id)

    const GenderIcon = genderIcons[patient.gender || 'unknown']
    const CONTEXT_MENU_ITEMS = [
        {
            title: t('share'),
            icon: 'share',
            onClick: onShare,
        },
        {
            title: t('add.to.collection'),
            icon: 'movetofolderDark',
            onClick: onAddToCollection,
        },
        {
            title: 'Add/Edit Tags',
            icon: 'tagIcnDark',
            onClick: onAddTag,
        },
        {
            title: t('download'),
            icon: 'downloadIcnDark',
            onClick: onDownload,
        },
        {
            title: t('delete'),
            icon: 'delete',
            onClick: onDelete,
        },
    ]

    return (
        <>
            <div className="patient-details-header">
                <div className="doctor-details">
                    <div className="patient-details-stack-wrapper">
                        <div className="patient-stack-name">
                            <span>{patient.name}</span>
                        </div>

                        <div className="patient-stack-information-wrapper">
                            <div className="patient-stack-information">
                                <div className="gender-icon-wrap">
                                    <GenderIcon size="m" />
                                </div>

                                <div className="custom-divider-sm"></div>
                                <div className="patient-stack-dob-age">
                                    <span>
                                        {format(patient.dateOfBirth, 'dd/MM/yyyy')} (
                                        {getAgeFromDob(patient.dateOfBirth) || 1})
                                    </span>
                                </div>

                                <div className="custom-divider-sm"></div>
                                <div className="patient-stack-id">
                                    <span>{patient.patientId}</span>
                                </div>
                            </div>
                            {data?.length > 0 && <TagPills data={data} sliceBy="3" />}
                        </div>
                    </div>
                </div>
                <div
                    className="header-more-details-wrapper"
                    data-ref={patient.id}
                    onClick={onToggle}
                >
                    <zui-icon-common-more-centered
                        data-ref={patient.id}
                        style={{ color: '#ffffff' }}
                    ></zui-icon-common-more-centered>
                </div>
            </div>
            {isOpen && <ContextMenu ref={myRef} onClick={onClose} options={CONTEXT_MENU_ITEMS} />}
        </>
    )
}

export default React.memo(PatientDetailsHeader)
